const form22 = document.querySelector('#gform_22');
let requiredElementsTab = [];
if('undefined'!=typeof(form22) && !!form22) {
    requiredElementsTab.push('1');

    let getNextSibling = function (elem, selector){
        let sibling = elem.nextElementSibling;
        if (!selector) return sibling;
        while (sibling) {
            if (sibling.matches(selector)) return sibling;
            sibling = sibling.nextElementSibling
        }
    };

    gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {



        if(22!=formId) return;
        let validationMessage;
        if('radio' == elem.type) {
            validationMessage = getNextSibling(elem.parentNode.parentNode.parentNode,'.gfield_validation_message');
        } else {
            validationMessage = getNextSibling(elem.parentNode,'.gfield_validation_message');
        }

        const dotIndex = fieldId.indexOf('.');
        fieldId = (dotIndex !== -1) ? fieldId.substring(0, dotIndex) : fieldId;

        if(requiredElementsTab.includes(fieldId)) {

            if('checkbox'==elem.type) {

                if(elem.checked) {
                    (undefined!==validationMessage) ? validationMessage.style.display = 'none' : null;
                    elem.setAttribute("aria-invalid", "false");
                } else {
                    (undefined!==validationMessage) ? validationMessage.style.display = 'block' : null;
                    elem.setAttribute("aria-invalid", "true");
                }

            } else if('radio'==elem.type) {

                (undefined!==validationMessage) ? validationMessage.style.display = 'none' : null;
                elem.parentNode.parentNode.parentNode.parentNode.classList.remove('gfield_error');

            } else {

                if(elem.value.length>0) {
                    (undefined!==validationMessage) ? validationMessage.style.display = 'none' : null;
                    elem.setAttribute("aria-invalid", "false");
                } else {
                    (undefined!==validationMessage) ? validationMessage.style.display = 'block' : null;
                    elem.setAttribute("aria-invalid", "true");
                }

            }

        }
    }, 10, 3 );






}